import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import TableSortLabel from '@mui/material/TableSortLabel';
import { equals } from 'ramda';
import { noop } from 'ramda-extension';

const SortCell = ({ sort = '', sortBy = '', onSort = noop, hasRecords = true, children }) => {
	const handleSort = () => {
		if (sortBy) {
			let asc = '';
			let desc = '';
			if (Array.isArray(sortBy)) {
				asc = sortBy.map((s) => `${s},asc`);
				desc = sortBy.map((s) => `${s},desc`);
			} else {
				asc = `${sortBy},asc`;
				desc = `${sortBy},desc`;
			}

			if (Array.isArray(sort)) {
				onSort(equals(sort, asc) ? desc : asc);
			} else {
				onSort(sort && sort === asc ? desc : asc);
			}
		}
	};

	let mainSortBy = sortBy;
	if (Array.isArray(sortBy)) {
		mainSortBy = sortBy[0];
	}

	let mainSort = sort;
	if (Array.isArray(sort)) {
		mainSort = sort[0];
	}

	const [name, type] = mainSort.split(',');

	return (
		// active always true - to supress hiding of arrow
		<Stack direction="row">
			<TableSortLabel
				active
				direction={name === mainSortBy && type === 'desc' ? 'desc' : 'asc'}
				onClick={hasRecords ? handleSort : noop}
				sx={{
					'.MuiTableSortLabel-icon': {
						color: (theme) =>
							hasRecords && name === mainSortBy
								? `${theme.palette.primary.main} !important`
								: 'text.primary',
					},
				}}
			>
				<Box sx={{ color: hasRecords && name === mainSortBy ? 'primary.main' : 'text.primary' }}>
					{children || ''}
				</Box>
			</TableSortLabel>
		</Stack>
	);
};

SortCell.propTypes = {
	children: PropTypes.any,
	hasRecords: PropTypes.bool,
	onSort: PropTypes.func,
	sort: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	sortBy: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

export default SortCell;
